import { render } from "./cm-tag.vue?vue&type=template&id=c65e3e18&scoped=true&ts=true"
import script from "./cm-tag.vue?vue&type=script&lang=ts"
export * from "./cm-tag.vue?vue&type=script&lang=ts"

import "./cm-tag.vue?vue&type=style&index=0&id=c65e3e18&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65e3e18"]])

export default __exports__